var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"","list-type":"picture-card","show-file-list":false,"http-request":_vm.uploadHttp,"accept":"image/*","before-upload":_vm.beforeUpload}},[(_vm.url)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.url}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }